export default function OurTeam() {
  const teamMembers = [
    {
      name: "Suleyman Akten",
      title: "Founder & Strategic Director",
      description: "Leads supplier relations and long-term marketplace strategy.",
      image: "https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/b268422fb374250b9d76a07cd4170cae.png"
    },
    {
      name: "Sumeyra Akten",
      title: "Operations & Compliance Manager",
      description: "Oversees day-to-day marketplace execution and policy compliance.",
      image: "https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/3c48c7624b1fe4337a85ca44eba73cbd.jpeg"
    },
    {
      name: "Hakan Koç",
      title: "Marketplace & Data Operations",
      description: "Manages pricing intelligence, optimization, and performance analytics.",
      image: "https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/89b333215abf2783262578ee74a2b440.png"
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Leadership Team
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            A focused leadership structure driving supplier partnerships and marketplace performance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
          {teamMembers.map((member, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <div
                className="w-36 lg:w-[10.5rem] overflow-hidden mb-5 border-3 border-gray-100 shadow-lg"
                style={{
                  height: '11rem',
                  borderRadius: '50% / 45%',
                }}
              >
                <img
                  src={`${member.image}?w=360&h=360&q=95`}
                  alt={member.name}
                  title={`${member.name} - ${member.title}`}
                  width="180"
                  height="180"
                  className="w-full h-full object-cover"
                  style={{ 
                    objectPosition: 'center 20%',
                    imageRendering: 'auto'
                  }}
                  loading="eager"
                  fetchPriority="high"
                  srcSet={`${member.image}?w=360&h=360&q=95 1x, ${member.image}?w=720&h=720&q=95 2x`}
                />
              </div>
              <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-1">
                {member.name}
              </h3>
              <p className="text-sm font-medium text-akten mb-4">
                {member.title}
              </p>
              <p className="text-gray-600 text-sm leading-relaxed max-w-xs">
                {member.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}